import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';

const {logger} = useBSSLogger();

const retrieveTipispedizione =  async () => {

    const {data} = await getapiclient().post(`tipospedizione/all`)

    logger.debug("tipi spedizione da webservice", data);

    return data;
}

export {retrieveTipispedizione}